import { getScheduleRuntimeMode } from "utils/scheduleSettings";
import {
  GETTING_STARTED_CLASS_ID,
  GETTING_STARTED_WELCOME_ANNOUNCEMENT_HTML,
  GETTING_STARTED_WELCOME_ANNOUNCEMENT_TEXT,
  buildGettingStartedClassData,
} from "utils/gettingStartedClass";
export function convertEmailToLowercase(email) {
  if (email && typeof email === "string") {
    return email.toLowerCase();
  }
  return email;
}

export function formatDateYYYYMMDD(inputDate) {
  const date = inputDate instanceof Date ? inputDate : new Date(inputDate);
  if (Number.isNaN(date.getTime())) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function getDate30DaysInFuture() {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 30);
  return formatDateYYYYMMDD(currentDate);
}

export function getNextSemesterTestsDate(referenceDate = new Date()) {
  const baseDate = referenceDate instanceof Date ? referenceDate : new Date(referenceDate);
  if (Number.isNaN(baseDate.getTime())) {
    return "2099-12-31";
  }

  const year = baseDate.getFullYear();
  const candidateDates = [
    new Date(year, 4, 20), // May 20
    new Date(year, 11, 15), // Dec 15
    new Date(year + 1, 4, 20),
    new Date(year + 1, 11, 15)
  ];

  const baseAtMidnight = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());
  const nextDate = candidateDates.find((candidate) => candidate.getTime() >= baseAtMidnight.getTime());
  return formatDateYYYYMMDD(nextDate || candidateDates[candidateDates.length - 1]);
}

export function buildDefaultAnnouncements() {
  return [
    {
      html: GETTING_STARTED_WELCOME_ANNOUNCEMENT_HTML,
      text: GETTING_STARTED_WELCOME_ANNOUNCEMENT_TEXT,
      active: true,
      show: true,
      lastEdited: "",
      dateCreated: "",
      classIds: [GETTING_STARTED_CLASS_ID],
      id: "id222222222",
      endDate: "2099-12-31",
      startDate: "2023-10-01"
    }
  ];
}

export function buildDefaultScheduleCalendar(userSettings = {}) {
  return {
    scheduleRuntimeMode: getScheduleRuntimeMode(userSettings),
    templates: [],
    assignments: [],
    schoolYearSettings: {
      hasConfigured: false,
      startMonth: 7,
      startDay: 1,
      endMonth: 6,
      endDay: 30,
    },
  };
}

export function buildDefaultSettings() {
  return {
    scheduleRuntimeMode: "calendar",
    showSeconds: true,
    logo: true,
    marqueeSpeed: "150",
    alteredSchedule: false,
    multiWeek: false,
    numberOfWeeks: 1,
    currentWeek: "A",
    differentTimes: false,
    useActiveDates: true,
    useShareCode: false,
    shareDateAccess: {
      mode: "any",
    },
    screenTimeout: "60",
    automaticCycleAdvance: true,
    masterVolume: 0.75,
    audioSettings: {
      alerts: 0.75,
      agendaAlerts: 0.75,
      music: 0.75,
      birthday: 0.75,
      timers: 0.75,
      widgets: 0.75,
    },
  };
}

export function buildDefaultClasses() {
  return [buildGettingStartedClassData()];
}
